export default {
  intro: `Please place the card on the reader on your left side. Wait 5 seconds, the key card will be generated. Afterwards, you can remove the card.`,
};
